import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  EXPLORE_SHELTERS_PATH,
  LEARNING_CENTER_PATH,
  STANDARDS_PATH
} from 'dpl/shared/constants/urls';
import SmartImage from 'dpl/components/SmartImage';

import menuSheltersJpg from 'dpl/assets/menu_shelters.jpg';
import menuLearningCenterJpg from 'dpl/assets/menu_learning_center.jpg';
import menuStandardsJpg from 'dpl/assets/menu_standards.jpg';

const USER_MENU_LINKS = [
  {
    path: EXPLORE_SHELTERS_PATH,
    title: 'Find shelters & rescues',
    image: menuSheltersJpg,
    shouldHide: true
  },
  {
    path: LEARNING_CENTER_PATH,
    title: 'Visit the learning center',
    image: menuLearningCenterJpg
  },
  {
    path: STANDARDS_PATH,
    title: 'Learn about our standards',
    image: menuStandardsJpg
  }
].filter(link => !link.shouldHide);

export default function BreederMobileHeaderDropdownLoggedOutContent({
  className
}) {
  return (
    <div
      className={classnames(
        'BreederMobileHeaderDropdownLoggedOutContent',
        className
      )}
    >
      <ul className="flex flex-column gap-16 fw-medium">
        {USER_MENU_LINKS.map(({ image, path, title }, index) => (
          <li
            className={classnames(
              'flex items-center gap-16',
              index > 0 && 'bt b--light-gray pt4'
            )}
            key={path}
          >
            <div className="flex items-center">
              <SmartImage height="64px" src={image} width="64px" />
            </div>
            <a href={path}>{title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

BreederMobileHeaderDropdownLoggedOutContent.propTypes = {
  className: PropTypes.string
};

BreederMobileHeaderDropdownLoggedOutContent.defaultProps = {
  className: null
};
